// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index-tab-permission .ql-container {\n  height: 234px;\n}\n.index-tab-permission .el-textarea.is-disabled textarea {\n  font-weight: 500;\n  color: #606266;\n}", ""]);
// Exports
module.exports = exports;
